<template>
  <v-container fluid>
    <enrollment-trending-graph
      :edited-site="editedSite"
      :org-trial-external-id="orgTrialExternalId"
      :trial-external-id="trialExternalId"
      :trial-id="selectedTrialId"
      :selected-trial-name="selectedTrialName"
    />
  </v-container>
</template>

<script>
import EnrollmentTrendingGraph from '@/components/insights/EnrollmentTrendingGraph'
import { TableTypes } from '@/helpers/table-helper'

export default {
  components: {
    EnrollmentTrendingGraph
  },
  props: {
    editedSite: { type: Object, default: null },
    selectedTable: { type: String, default: TableTypes.SUMMARY },
    preSelectedGraphType: { type: String, required: true },
    preSelectedTraces: { type: Array, default: () => [] },
    selectedTrialId: { type: String, default: null },
    selectedTrialName: { type: String, default: null },
    trialExternalId: { type: String, default: null },
    summaries: { type: Array, default: () => [] },
    orgTrialExternalId: { type: String, default: null }
  }
}
</script>
